import { render, staticRenderFns } from "./EditAreaForm.vue?vue&type=template&id=b32bc1cc&"
import script from "./EditAreaForm.vue?vue&type=script&lang=js&"
export * from "./EditAreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports